import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/instantInstallment';
import InstantInstallmentModel from '../models/instantInstallment.m';
import {apiback} from '../../../config';
import widgetsHelper from 'utils/getWidget.helper';

const defaultInstantInstallment = 'default_instant_installment';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            selectedType: defaultInstantInstallment,
            model: {},
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: []
        };

        this.crefs = {};
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    componentWillMount() {
        fetch(apiback('INSTANT_INSTALLMENT'))
            .then(response => response.json())
            .then(json =>
                this.setState({
                    model: new InstantInstallmentModel(
                        json.data[defaultInstantInstallment],
                        this.state.selectedType
                    )
                })
            );
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    }

    componentWillReady() {
        this.widgetsHelper.getWidgets.call(this);
    }

    static displayName = 'Credit.Views.InstantInstallment';

    static contextTypes = {
        app: PropTypes.object
    };
}
